var _metadata, _defs, _g, _g2, _g3, _mask, _g4, _mask2, _g5, _g6, _mask3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.32366476556058 94.91654796759678",
    width: 69.32366476556058,
    height: 94.91654796759678,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    className: "style-fonts"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(16.689434132275977 18.897311803825687) rotate(319.22817214747965 7.686409941186483 3.0736082668459517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.54 0 C4.98 0, 8.42 0, 13.84 0 M1.54 0 C6.04 0, 10.55 0, 13.84 0 M13.84 0 C14.86 0, 15.37 0.51, 15.37 1.54 M13.84 0 C14.86 0, 15.37 0.51, 15.37 1.54 M15.37 1.54 C15.37 2.29, 15.37 3.05, 15.37 4.61 M15.37 1.54 C15.37 2.23, 15.37 2.92, 15.37 4.61 M15.37 4.61 C15.37 5.63, 14.86 6.15, 13.84 6.15 M15.37 4.61 C15.37 5.63, 14.86 6.15, 13.84 6.15 M13.84 6.15 C11.29 6.15, 8.74 6.15, 1.54 6.15 M13.84 6.15 C10.03 6.15, 6.23 6.15, 1.54 6.15 M1.54 6.15 C0.51 6.15, 0 5.63, 0 4.61 M1.54 6.15 C0.51 6.15, 0 5.63, 0 4.61 M0 4.61 C0 3.83, 0 3.06, 0 1.54 M0 4.61 C0 3.96, 0 3.31, 0 1.54 M0 1.54 C0 0.51, 0.51 0, 1.54 0 M0 1.54 C0 0.51, 0.51 0, 1.54 0",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(14.23652213547578 38.00688893845154) rotate(0 22.5435713150424 23.454829514572623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.27 0 C18.3 0, 25.32 0, 33.82 0 M11.27 0 C19.15 0, 27.03 0, 33.82 0 M33.82 0 C41.33 0, 45.09 3.76, 45.09 11.27 M33.82 0 C41.33 0, 45.09 3.76, 45.09 11.27 M45.09 11.27 C45.09 18.84, 45.09 26.41, 45.09 35.64 M45.09 11.27 C45.09 16.17, 45.09 21.07, 45.09 35.64 M45.09 35.64 C45.09 43.15, 41.33 46.91, 33.82 46.91 M45.09 35.64 C45.09 43.15, 41.33 46.91, 33.82 46.91 M33.82 46.91 C25.6 46.91, 17.38 46.91, 11.27 46.91 M33.82 46.91 C26.79 46.91, 19.77 46.91, 11.27 46.91 M11.27 46.91 C3.76 46.91, 0 43.15, 0 35.64 M11.27 46.91 C3.76 46.91, 0 43.15, 0 35.64 M0 35.64 C0 29.42, 0 23.2, 0 11.27 M0 35.64 C0 28.98, 0 22.32, 0 11.27 M0 11.27 C0 3.76, 3.76 0, 11.27 0 M0 11.27 C0 3.76, 3.76 0, 11.27 0",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.482823096611526 46.8783767842267) rotate(0.22564943739691018 0.09863036619324816 14.248695662780165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.03 4.75, 0.16 23.75, 0.2 28.5 M0 0 C0.03 4.75, 0.16 23.75, 0.2 28.5",
    stroke: "#005e79",
    strokeWidth: 4,
    fill: "none"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.807177223600632 47.979093026824216) rotate(0.22564943739691018 0.043529794617327866 13.172595791142442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.01 4.39, 0.07 21.95, 0.09 26.35 M0 0 C0.01 4.39, 0.07 21.95, 0.09 26.35",
    stroke: "#005e79",
    strokeWidth: 4,
    fill: "none"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(6.741236401143823 23.517070336217444) rotate(319.22817214747965 21.86333108519041 3.1347016131629744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.57 0 C12.1 0, 22.63 0, 42.16 0 M1.57 0 C15.65 0, 29.74 0, 42.16 0 M42.16 0 C43.2 0, 43.73 0.52, 43.73 1.57 M42.16 0 C43.2 0, 43.73 0.52, 43.73 1.57 M43.73 1.57 C43.73 2.24, 43.73 2.92, 43.73 4.7 M43.73 1.57 C43.73 2.28, 43.73 2.99, 43.73 4.7 M43.73 4.7 C43.73 5.75, 43.2 6.27, 42.16 6.27 M43.73 4.7 C43.73 5.75, 43.2 6.27, 42.16 6.27 M42.16 6.27 C27.1 6.27, 12.03 6.27, 1.57 6.27 M42.16 6.27 C26.4 6.27, 10.64 6.27, 1.57 6.27 M1.57 6.27 C0.52 6.27, 0 5.75, 0 4.7 M1.57 6.27 C0.52 6.27, 0 5.75, 0 4.7 M0 4.7 C0 3.82, 0 2.93, 0 1.57 M0 4.7 C0 4.07, 0 3.45, 0 1.57 M0 1.57 C0 0.52, 0.52 0, 1.57 0 M0 1.57 C0 0.52, 0.52 0, 1.57 0",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.27864883023207 48.32816315776802) rotate(0.22564943739691018 0.043529794617327866 13.172595791142442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.01 4.39, 0.07 21.95, 0.09 26.35 M0 0 C0.01 4.39, 0.07 21.95, 0.09 26.35",
    stroke: "#005e79",
    strokeWidth: 4,
    fill: "none"
  })))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashOpen);
export default __webpack_public_path__ + "static/media/trash-open.0e7103751fb4571d94cb4af6a83a04f2.svg";
export { ForwardRef as ReactComponent };